import { pbClient } from "../lib/PB/pb";

export const fetchApi = (url: string, options?: RequestInit) => fetch(url, options)

export const isAuthenticated = () => pbClient.authStore.isValid

export function getDeviceType() {
    // const userAgent = window.navigator.userAgent;
    const platform = window.navigator.platform;
    const macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'];
    const windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'];
    const iosPlatforms = ['iPhone', 'iPad', 'iPod'];
    const osPlatforms = ['Linux', 'Android'];

    if (macosPlatforms.indexOf(platform) !== -1) {
        return 'Mac';
    } else if (iosPlatforms.indexOf(platform) !== -1) {
        return 'iOS';
    } else if (windowsPlatforms.indexOf(platform) !== -1) {
        return 'Windows';
    } else if (osPlatforms.indexOf(platform) !== -1) {
        return 'Android';
    }

    return 'unknown';
}

console.log(getDeviceType());
